/**
 * RESPONSIBILITY: the band that sends people to the channel for older sermons.
 *
 * It is what keeps the sermons list bounded: an archive nobody has to maintain.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Paragraph, Link } from '@framework/core/decorators';
import { SectionName } from '../section-names';

@Section({ name: SectionName.SermonsArchive, label: 'Sermons — the archive' })
export class SermonsArchiveSection {
  @Text({ label: 'Title', maxLength: 300, default: 'Looking for something older?' })
  archiveHeading!: string;

  @Paragraph({ label: 'Description', maxLength: 4000, rows: 2 })
  archiveBody!: string;

  @Text({ label: 'Button text', maxLength: 120, default: 'Open YouTube' })
  archiveLabel!: string;

  @Link({
    label: 'Button link',
    description: 'The YouTube channel the button opens.',
  })
  channelUrl!: string;
}
